import React, { useEffect, useState } from 'react';
import { BlockStack, Card, InlineGrid, Text } from '@shopify/polaris';
import { cacApi } from './apiClient';

// Counts above the Review list: the mockup's tiles, from GET /status and the pending-values list.
export default function StatusTiles() {
  const [s, setS] = useState(null);
  const [pending, setPending] = useState(null);
  useEffect(() => {
    cacApi.status().then(setS).catch(() => {});
    cacApi.pending().then((r) => setPending(r.values.length)).catch(() => {});
  }, []);
  if (!s) return null;
  const b = s.by_status || {};
  const tiles = [
    [(b.proposed || 0) + (b.edited || 0), 'awaiting review'], [b.approved || 0, 'approved, not written'], [b.written || 0, 'written'], [b.failed || 0, 'failed'],
    [s.scope.in_catalog, 'products in catalog'], [s.ai_done ?? 0, 'been through AI'], [s.scope.no_image, 'without an image'], [s.scope.team_portal, 'Team Portal'], [pending ?? '—', 'pending values'],
  ];
  return (
    <div style={{ marginBottom: 16 }}>
      <InlineGrid columns={{ xs: 2, sm: 3, lg: 9 }} gap="200">
        {tiles.map(([n, label]) => (
          <Card key={label}><BlockStack gap="050"><Text as="span" variant="headingLg" numeric>{typeof n === 'number' ? n.toLocaleString() : n}</Text><Text as="span" variant="bodySm" tone="subdued">{label}</Text></BlockStack></Card>
        ))}
      </InlineGrid>
    </div>
  );
}
